import { api } from "./api";

export const storesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getStores: builder.query({
      query: () => "api/Stock/Stores",
      providesTags: ["stores"],
    }),
    addStore: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Stores",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["stores"],
    }),
    editStore: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Stores",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["stores"],
    }),
    deleteStore: builder.mutation({
      query: (storeId) => ({
        url: `api/Stock/Stores?StoreID=${storeId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["stores"],
    }),

    // Configuration
    getStoresSetting: builder.query({
      query: () => "api/Stock/Configuration",
      providesTags: ["stores"],
    }),
    updateStoresSetting: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Configuration",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["stores"],
    }),
  }),
});

export const {
  useGetStoresQuery,
  useAddStoreMutation,
  useEditStoreMutation,
  useDeleteStoreMutation,
  //
  useGetStoresSettingQuery,
  useUpdateStoresSettingMutation,
} = storesApi;
